import { useRef, useCallback, useEffect } from 'react';
import { containerCls, shapeCls } from './Shape.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { RenderShape } from '../../shapes/RenderShape.js';

const Shape = ({
  sheetRef,
  pageId,
  pageAspectRatio,
  zIndex,
  item,
  isSelected,
  isCloned,
  onSelect,
  onDragStart,
  Before,
  After
}) => {
  const ref = useRef(null);
  const handleSelect = useCallback(evt => {
    if (onSelect !== undefined) {
      onSelect(evt, item);
    }
  }, [item, onSelect]);
  useEffect(() => {
    const node = ref.current;
    if (node === null) {
      return;
    }
    node.addEventListener("focusin", handleSelect, {
      passive: false
    });
    node.addEventListener("mousedown", handleSelect, {
      passive: false
    });
    node.addEventListener("touchstart", handleSelect, {
      passive: false
    });
    return () => {
      node.removeEventListener("focusin", handleSelect);
      node.removeEventListener("mousedown", handleSelect);
      node.removeEventListener("touchstart", handleSelect);
    };
  }, [item, handleSelect]);
  const handlePointerDragStart = evt => {
    if (!item.settings.cloneable && !item.settings.movable) {
      return;
    }
    onDragStart?.(evt, item);
  };
  const handleKeyDown = evt => {
    if ((evt.key === " " || evt.key === "Enter") && !document.body.classList.contains("isDragging")) {
      onDragStart?.(evt, item);
    }
  };
  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    jsxs("div", {
      ref: ref,
      onMouseDown: handlePointerDragStart,
      onTouchStart: handlePointerDragStart,
      onKeyDown: handleKeyDown,
      "data-drag-target": true,
      "data-id": item.id,
      className: containerCls,
      style: {
        zIndex,
        left: `${(item.position.x * 100).toString()}%`,
        top: `${(item.position.y * 100).toString()}%`,
        width: `${(item.size.width * 100).toString()}%`,
        height: `${(item.size.height * 100).toString()}%`,
        transform: item.angleInRadian !== 0 ? `rotate(${item.angleInRadian.toString()}rad)` : undefined
      },
      children: [Before !== undefined && /*#__PURE__*/jsx(Before, {
        sheetRef: sheetRef,
        pageId: pageId,
        pageAspectRatio: pageAspectRatio,
        isSelected: isSelected,
        isCloned: isCloned,
        item: item
      }), /*#__PURE__*/jsx(RenderShape, {
        type: item.type,
        className: shapeCls,
        preserveAspectRatio: "none",
        fillColor: item.style.fillColor,
        strokeColor: item.style.strokeColor
      }), After !== undefined && /*#__PURE__*/jsx(After, {
        sheetRef: sheetRef,
        pageId: pageId,
        pageAspectRatio: pageAspectRatio,
        isSelected: isSelected,
        isCloned: isCloned,
        item: item,
        onDragStart: onDragStart
      })]
    })
  );
};

export { Shape };
//# sourceMappingURL=Shape.js.map
